import {get} from "@/util/requestUtils"

export function getAnnouncementList(params, success) {
  return get("/message/public-api/announcement/list", params, success)
}

export function getAnnouncement(params, success) {
  return get("/message/public-api/announcement", params, success)
}
